<script setup>
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import SearchResultSection from './SearchResultSection.vue';
import SearchResultWebCustomerItem from './SearchResultWebCustomerItem.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  customers: { type: Array, default: () => [] },
  query: { type: String, default: '' },
  isFetching: { type: Boolean, default: false },
  showTitle: { type: Boolean, default: true },
});

const router = useRouter();
const { t } = useI18n();

const openCustomersList = query => {
  router.push({
    name: 'web_order_customers',
    query: { q: query, page: '1' },
  });
};
</script>

<template>
  <SearchResultSection
    :title="$t('SEARCH.SECTION.WEB_CUSTOMERS')"
    :empty="!customers.length"
    :query="query"
    :show-title="showTitle"
    :is-fetching="isFetching"
  >
    <ul v-if="customers.length" class="list-none space-y-3">
      <li v-for="customer in customers" :key="customer.id">
        <SearchResultWebCustomerItem :customer="customer" />
      </li>
    </ul>
    <NextButton
      v-if="customers.length && query"
      class="mt-3"
      :label="t('SEARCH.VIEW_IN_CUSTOMERS_LIST')"
      icon="i-lucide-list"
      slate
      sm
      outline
      @click="openCustomersList(query)"
    />
  </SearchResultSection>
</template>
